import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-gray-200">
      <SliderPrimitive.Range className="absolute h-full bg-[#E2AB20]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-4 w-4 rounded-full border border-[#E2AB20]/60 bg-white shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E2AB20] disabled:pointer-events-none disabled:opacity-50" />
    <SliderPrimitive.Thumb
      className="block h-4 w-4 rounded-full border border-[#E2AB20]/60 bg-white shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E2AB20] disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
